export default "__VITE_ASSET__ReQ3$2gG84Su$nlCVf63EA__"